import { useEffect, useState } from "react";
import { History, Smartphone, Loader2 } from "lucide-react";
import { fotoApi, fotoError } from "./fotoApi";

const fmt = (iso) => {
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "—";
  const p = (n) => String(n).padStart(2, "0");
  return `${p(d.getDate())}/${p(d.getMonth() + 1)}/${d.getFullYear()} ${p(d.getHours())}:${p(d.getMinutes())}`;
};

export const FotoCronologia = ({ praticaId, refreshKey }) => {
  const [rows, setRows] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    setErr("");
    fotoApi.get(`/pratiche/${praticaId}/cronologia`).then(({ data }) => setRows(data || [])).catch((e) => { setErr(fotoError(e)); setRows([]); });
  }, [praticaId, refreshKey]);

  return (
    <section className="space-y-2" data-testid="foto-cronologia">
      <h2 className="flex items-center gap-2 text-sm font-semibold uppercase tracking-wider text-slate-500"><History className="h-4 w-4" />Cronologia foto</h2>
      {rows === null && <p className="flex items-center gap-2 text-sm text-slate-500"><Loader2 className="h-4 w-4 animate-spin" />Caricamento…</p>}
      {err && <p className="text-sm text-red-700" role="alert" data-testid="foto-cronologia-error">{err}</p>}
      {rows && !rows.length && !err && <p className="text-sm text-slate-500" data-testid="foto-cronologia-empty">Nessuna foto caricata per questa pratica.</p>}
      {rows && rows.length > 0 && (
        <ul className="divide-y divide-slate-200 rounded-xl border border-slate-200 bg-white">
          {rows.map((r) => (
            <li key={r.id} className="flex items-center justify-between gap-2 px-3 py-2 text-sm text-slate-800" data-testid={`foto-cronologia-${r.id}`}>
              <span className="min-w-0 break-words"><span className="font-mono whitespace-nowrap">{fmt(r.data)}</span> · {r.cartella}</span>
              {r.da_telefono && (
                <span className="shrink-0 inline-flex items-center gap-1 rounded-full bg-amber-100 px-2 py-0.5 text-[11px] font-semibold text-amber-800" data-testid={`foto-cronologia-tel-${r.id}`}>
                  <Smartphone className="h-3 w-3" />da telefono
                </span>
              )}
            </li>
          ))}
        </ul>
      )}
    </section>
  );
};
